import { render, staticRenderFns } from "./healthWorkerView.vue?vue&type=template&id=1b1fd8d3&"
import script from "./healthWorkerView.vue?vue&type=script&lang=js&"
export * from "./healthWorkerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports